import http from "./http-common";
import qs from 'qs';
import authHeader from "./auth-header";
import UrlService from "./url.service";
import {API_URL} from "../utils/config.util";
import {receiptOwnerPath} from "../utils/customer.context";

class ReceiptService {

  create(mid, data) {
    return http.post(UrlService.getBffUrl() + `/v1/merchants/${mid}/receipts`, data, {headers: authHeader()});
  }

  update(mid, id, data) {
    return http.put(UrlService.getBffUrl() + `/v1/merchants/${mid}/receipts/${id}`, data, {headers: authHeader()});
  }

  refund(mid, id) {
    return http.put(UrlService.getBffUrl() + `/v1/merchants/${mid}/receipts/${id}/refund`, {}, {headers: authHeader()});
  }

  email(mid, id, data) {
    return http.post(UrlService.getBffUrl() + `/v1/merchants/${mid}/receipts/${id}/email`, data, {headers: authHeader()});
  }

  // Customer contacts use their customer's route (see customer.context.js).
  findById(mid, id) {
    return http.get(UrlService.getBffUrl() + receiptOwnerPath(mid, `/receipts/${id}`), {headers: authHeader()});
  }

  find(mid, params) {
    return http.get(UrlService.getBffUrl() + receiptOwnerPath(mid, '/receipts'), {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'});
      },
      headers: authHeader()
    });
  }

  delete(mid, id) {
    return http.delete(API_URL + `/v1/merchants/${mid}/receipts/${id}`, {headers: authHeader()});
  }

  handleResponse(response) {
    return response;
  }

  getProjectIncomeReport(merchantId, params) {
    return http.get(API_URL + `/v1/merchants/${merchantId}/reports/receipts/project`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'});
      },
      headers: authHeader()
    });
  }

  getUncategorizedIncomeReport(merchantId, params) {
    return http.get(API_URL + `/v1/merchants/${merchantId}/reports/receipts/uncategorized`, { 
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'});
      },
      headers: authHeader()
    });
  }
}

export default new ReceiptService();



// WEBPACK FOOTER //
// ./src/service/receipt.service.js